const PaymentSourceTypes = {
  CREDIT_CARD: 'CREDIT_CARD',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  _Values: () =>
    Object.keys(PaymentSourceTypes)
      .filter(key => typeof PaymentSourceTypes[key] !== 'function')
      .map(key => PaymentSourceTypes[key]),
};

const VantivCardTypes = {
  VI: 'VI',
  MC: 'MC',
  AX: 'AX',
  DI: 'DI',
  DC: 'DC',
  JC: 'JC',
  _Values: () =>
    Object.keys(VantivCardTypes)
      .filter(key => typeof VantivCardTypes[key] !== 'function')
      .map(key => VantivCardTypes[key]),
};

const PaymentSourceCardTypes = {
  VISA: 'VISA',
  MASTER_CARD: 'MASTER CARD',
  AMEX: 'AMEX',
  DINER: 'DINER',
  DISCOVER: 'DISCOVER',
  JCB: 'JCB',
};

const PaymentScheduleTypes = {
  ONE_SHOT: 'ONE_SHOT',
  RECURRING: 'RECURRING',
  _Values: () =>
    Object.keys(PaymentScheduleTypes)
      .filter(key => typeof PaymentScheduleTypes[key] !== 'function')
      .map(key => PaymentScheduleTypes[key]),
};

const PaymentStatusTypes = {
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  AUTHORIZED: 'AUTHORIZED',
  APPROVED: 'APPROVED',
  REFUND: 'REFUND',
  SETTLED: 'SETTLED',
  SCHEDULED: 'SCHEDULED',
  RETURNED: 'RETURNED',
  REFUNDED: 'REFUNDED',
  REFUND_FAILED: 'REFUND_FAILED',
  CANCELLED: 'CANCELLED',
  VOID: 'VOID',
  REJECTED: 'REJECTED',
  DECLINED: 'DECLINED',
};

const PaymentTypes = {
  DOMUSO_CASH: 'DOMUSO_CASH',
  APPLICATION_FEE: 'APPLICATION_FEE',
  RESVN_FEE: 'RESVN_FEE',
  DEPOSIT: 'DEPOSIT',
  CHARGE: 'CHARGE',
  SVC_FEE: 'SVC_FEE',
  INSTALLMENT: 'INSTALLMENT',
  PREFUND: 'PREFUND',
  RENT: 'RENT',
  RECURRING: 'RECURRING',
  ONE_SHOT: 'ONE_SHOT',
  _Values: () =>
    Object.keys(PaymentTypes)
      .filter(key => typeof PaymentTypes[key] !== 'function')
      .map(key => PaymentTypes[key]),
};

const getHumanReadableCardType = vantivCardType => {
  switch (vantivCardType) {
    case 'VI':
      return PaymentSourceCardTypes.VISA;
    case 'MC':
      return PaymentSourceCardTypes.MASTER_CARD;
    case 'AX':
      return PaymentSourceCardTypes.AMEX;
    case 'DC':
      return PaymentSourceCardTypes.DINER;
    case 'DI':
      return PaymentSourceCardTypes.DISCOVER;
    case 'JC':
      return PaymentSourceCardTypes.JCB;
    default:
      return vantivCardType;
  }
};

const OrderSourceTypes = {
  ECOMMERCE: 'ecommerce',
  INSTALLMENT: 'installment',
  MAILORDER: 'mailorder',
  RECURRING: 'recurring',
  RETAIL: 'retail',
  TELEPHONE: 'telephone',
  AUTHENTICATED_3DS: '3dsAuthenticated',
  ATTEMPTED_3DS: '3dsAttempted',
  RECURRINGTEL: 'recurringtel',
  ECHECKPPD: 'echeckppd',
  APPLEPAY: 'applepay',
  _Values: () =>
    Object.keys(OrderSourceTypes)
      .filter(key => typeof OrderSourceTypes[key] !== 'function')
      .map(key => OrderSourceTypes[key]),
};

const ProcessingTypes = {
  ACCOUNT_FUNDING: 'accountFunding',
  INITIAL_RECURRING: 'initialRecurring',
  INITIAL_INSTALLMENT: 'initialInstallment',
  CARDHOLDER_INITIATED_COF: 'cardholderInitiatedCOF',
  MERCHANT_INITIATED_COF: 'merchantInitiatedCOF',
  INITIAL_COF: 'initialCOF',
  _Values: () =>
    Object.keys(ProcessingTypes)
      .filter(key => typeof ProcessingTypes[key] !== 'function')
      .map(key => ProcessingTypes[key]),
};

/**
 * See accType on p 330 in LitleXML Reference Guide
 * Enum = Checking, Savings, Corporate, Corp Savings
 */
const BankAccountTypes = {
  CHECKING: 'CHECKING',
  SAVINGS: 'SAVINGS',
  CORPORATE: 'CORPORATE',
  CORP_SAVINGS: 'CORP_SAVINGS',
  _Values: () =>
    Object.keys(BankAccountTypes)
      .filter(key => typeof BankAccountTypes[key] !== 'function')
      .map(key => BankAccountTypes[key]),
};

module.exports = {
  PaymentSourceTypes,
  VantivCardTypes,
  PaymentScheduleTypes,
  PaymentSourceCardTypes,
  PaymentStatusTypes,
  PaymentTypes,
  OrderSourceTypes,
  ProcessingTypes,
  BankAccountTypes,
  getHumanReadableCardType,
};
